import { render, staticRenderFns } from "./CreateLearningVectorModal.vue?vue&type=template&id=3cb08e90&scoped=true&"
import script from "./CreateLearningVectorModal.vue?vue&type=script&lang=ts&"
export * from "./CreateLearningVectorModal.vue?vue&type=script&lang=ts&"
import style0 from "../theme/plugins/themify-icons/themify-icons.css?vue&type=style&index=0&id=3cb08e90&prod&scoped=true&lang=css&"
import style1 from "./CreateLearningVectorModal.vue?vue&type=style&index=1&id=3cb08e90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb08e90",
  null
  
)

export default component.exports